<!-- 创建时间2024/04/24 18:03:17 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述： -->
<template>
  <div class="yxtbiz-doc-player--html" v-loading="loading">
    <div ref="doc" class="tencent-content"></div>
    <slot v-if="!showTencentWatermark" name="watermark"></slot>
  </div>
</template>

<script>
import 'whatwg-fetch';
import { getFileHtml } from 'yxt-biz-pc/packages/doc-viewer/src/service.js';
import '../../../doc-viewer/src/tencent-sdk.js';
import propsMixin from '../mixins/props';
export default {
  name: 'tencent-viewer',
  mixins: [propsMixin],
  inject: ['getZoom'],
  data() {
    return {
      loading: false
    };
  },
  computed: {
    zoom() {
      return this.getZoom();
    },
    showTencentWatermark() { // 固定水印，用对接腾讯sdk的水印
      const {enabled, type} = this.watermarkConfig;
      return enabled && type === 1;
    }
  },
  watch: {
    zoom(val) {
      const zoom = (1 + (this.zoom > 0 ? 0.3 : 0.1) * this.zoom) * 100;
      this.setZoom(zoom);
    }
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.instance && this.instance.destroy && this.instance.destroy();
  },
  methods: {
    // refreshViewer() {
    //   this.$nextTick(() => {
    //     const zoom = (1 + (this.zoom > 0 ? 0.3 : 0.1) * this.zoom) * 100;
    //     this.setZoom(zoom);
    //   });
    // },
    async init() {
      this.loading = true;
      const fileUrl = await getFileHtml(this.fileId);
      let previewUrl = `${fileUrl}&ci-process=doc-preview&dsttype=html&weboffice_url=1&sign=AuthString&versionid=1`;
      if (this.showTencentWatermark) {
        const safe_chinese_url = str => window.btoa(window.unescape(window.encodeURI(str))).replace(/\+/g, '-').replace(/\//g, '_');
        const safe_url = str => window.btoa(str).replace(/\+/g, '-').replace(/\//g, '_');
        // 密度计算
        const {htmlhorizontal, htmlvertical} = this.getDensityConfig(this.watermarkConfig.density);
        const waterWord = safe_chinese_url(this.watermarkConfig.text);
        const waterStyle = this.watermarkConfig.color ? `&htmlfillstyle=${safe_url(this.getRgba())}` : '';
        const waterFront = this.watermarkConfig.fontSize ? `&htmlfront=${safe_url(this.watermarkConfig.fontSize + 'px')}` : '';
        previewUrl += `&htmlhorizontal=${htmlhorizontal}&htmlvertical=${htmlvertical}&htmlwaterword=${waterWord}${waterStyle}${waterFront}`;
      }
      const response = await fetch(previewUrl);
      const res = await response.json();
      this.loading = false;
      if (res && res.PreviewUrl) {
        this.instance = window.COSDocPreviewSDK && window.COSDocPreviewSDK.config({
          mount: this.$refs.doc,
          mode: 'simple', // 'normal' / 'simple'
          url: res.PreviewUrl,
          commonOptions: {
            isShowTopArea: true,
            isShowHeader: false
          },
          cooperUserAttribute: {
            isCooperUsersAvatarVisible: false
          }
        });
      }
      await this.instance.ready();
      // 当前页改变事件
      if (this.instance.PPTApplication) {
        await this.initPptType();
      } else if (this.instance.WordApplication) {
        await this.initWordType();
      } else if (this.instance.ExcelApplication) {
        await this.initExcelType();
      } else if (this.instance.PDFApplication) {
        await this.initPdfType();
      }
      this.scrollToPage(this.start);
    },
    getRgba() {
      const hex = this.watermarkConfig.color;
      const opacity = this.watermarkConfig.opacity;
      let r, g, b;
      r = parseInt(hex.substr(1, 2), 16);
      g = parseInt(hex.substr(3, 2), 16);
      b = parseInt(hex.substr(5, 2), 16);
      return `rgb(${r},${g},${b}, ${opacity / 100})`;
    },
    getDensityConfig(density) {
      const densityValues = {
        0: { htmlhorizontal: 450, htmlvertical: 350 },
        1: { htmlhorizontal: 250, htmlvertical: 350 },
        2: { htmlhorizontal: 50, htmlvertical: 100 }
      };

      return densityValues[density] || { htmlhorizontal: 250, htmlvertical: 200 };
    },
    async initPptType() {
      this.app = this.instance.PPTApplication();
      this.app.Sub.SlideSelectionChanged = this.pageChange;
      this.app.Sub.SlideShowOnNext = this.pageChange;
      const total = await this.app.ActivePresentation.Slides.Count;
      this.setTotalPage(total);
      this.scrollToPage = page => this.app.ActivePresentation.SlideShowWindow.View.GotoSlide(page);
      this.setZoom = val => (this.app.ActivePresentation.View.Zoom = val);
    },
    async _getWordPage(wdInfoEnum) {
      return new Promise(resolve => {
        let times = 3;
        const getPagesCount = () => setTimeout(async() => {
          const pages = await this.app.ActiveDocument.Range.Information(wdInfoEnum);
          if (pages.End) {
            resolve(pages.PagesCount || 1);
          } else if (times > 0) {
            times--;
            getPagesCount();
          } else {
            resolve(1);
          }
        }, 100);
        getPagesCount();
      });
    },
    async initWordType() {
      this.app = this.instance.WordApplication();
      this.app.Sub.CurrentPageChange = this.pageChange;
      const Enum = this.app.Enum;
      const wdInfoEnum = Enum.WdInformation.wdNumberOfPagesInDocument;
      const wdGotoEnum = Enum.WdGoToItem.wdGoToPage;
      const wdGoToAbsolute = Enum.WdGoToDirection.wdGoToAbsolute;
      const total = await this._getWordPage(wdInfoEnum);
      this.setTotalPage(total);
      this.scrollToPage = page => this.app.ActiveDocument.Selection.GoTo(wdGotoEnum, wdGoToAbsolute, page);
      this.setZoom = val => (this.app.ActiveDocument.ActiveWindow.View.Zoom.Percentage = val);
    },
    async initExcelType() {
      this.app = this.instance.ExcelApplication();
      this.app.Sub.Worksheet_Activate = this.pageChange;
      const total = await this.app.Sheets.Count;
      this.setTotalPage(total);
      this.excelSheetNames = [];
      for (let index = 1; index <= total; index++) {
        this.excelSheetNames.push(await this.app.Sheets.Item(index).Name);
      }
      this.scrollToPage = page => this.app.Sheets.Item(page).Activate();
      this.setZoom = val => (this.app.ActiveSheetView.Zoom = val);
    },
    async initPdfType() {
      this.app = this.instance.PDFApplication();
      this.app.Sub.CurrentPageChange = this.pageChange;
      const total = await this.app.ActivePDF.PagesCount;
      this.setTotalPage(total);
      this.scrollToPage = page => this.app.ActivePDF.JumpToPage({ PageNum: page });
      this.setZoom = val => (this.app.ActivePDF.Zoom = val);
    },
    async pageChange(e) {
      if (this.excelSheetNames) {
        const name = await this.app.ActiveSheet.Name;
        e = this.excelSheetNames.findIndex(v => v === name) + 1;
      } else if (this.instance.PDFApplication) {
        e += 1;
      }
      this.$root.$emit('PAGE_CHANGE', e);
    },
    setTotalPage(total) {
      this.$root.$emit('PAGES_INIT', total);
    }
  }
};
</script>